// @flow
'use strict';

import * as React from 'react';
import { MenuItem } from 'react-bootstrap';

type BotaoExportacaoLoteProps = {
  abreModalPdf : () => void,
  abreModalXml : () => void,
}

export default function BotaoExportacaoLoteNfce({ abreModalPdf, abreModalXml } : BotaoExportacaoLoteProps) {
  return (
      <>
        <MenuItem onClick={ abreModalPdf }>DANFE</MenuItem>
        <MenuItem onClick={ abreModalXml }>XML</MenuItem>
      </>
  );
}
